let baseUrl = 'https://app.squadrun.co';
let vendorToString = {
  smalltalk: 'English Language Test - Small talk',
  languify: 'English Language Test - Languify',
  jotform: 'Sales Proficiency Test',
  mercer: 'English Language Test - Mercer mettl',
};

let statusToString = {
  not_attempted: 'Not Attempted',
  completed: 'Completed',
  submitted: 'Submitted',
  passed: 'Passed',
  failed: 'Failed',
};

let statusToColor = {
  not_attempted: 'warning',
  completed: 'success',
  submitted: 'success',
  passed: 'success',
  failed: 'error',
};

export default {
  baseUrl,
  statusToColor,
  statusToString,
  vendorToString,
};
